import { Box, Typography } from "@mui/material"
import separationImg from "assets/images/separation-white.svg"
import { Button } from "components"

import { useRef, useState, RefObject, useEffect } from "react"
import { FaCog } from "react-icons/fa"
import { useSelector } from "react-redux"

import { BoxAlign, Configs, Container, TextHelper, TextWarning, TitlePage } from "./styles"
import { animateValue } from "utils/animateNumber"
import { ReturnArea } from "./ReturnArea"
import { DialogEdit } from "./DialogEdit"
import { ContainerPage } from "components/ContainerPage"
import { configsService } from "services/configsService"
import { toast } from "react-toastify"
import { IConfigDataRequest, IConfigDataResponse } from "interfaces/IConfig"

export const Markets = () => {
  const ref: RefObject<HTMLElement> = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [totalMarkets, setTotalMarkets] = useState(0)
  const [configResponse, setConfigResponse] = useState<IConfigDataResponse | null>(null)
  const [dialogEditSeparation, setDialogEditSeparation] = useState({
    isOpen: false,
    data: 0,
  })

  const handleGetConfigs = async () => {
    try {
      setIsLoading(true)
      const response = await configsService.getConfig()
      setConfigResponse(response)
      setTotalMarkets(response.totalMarkets)
    } catch (error: any) {
      toast(error?.message ?? "Deu erro pra buscar as configurações, avisa o time de tech.", {
        type: "error",
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleUpdateConfigs = async (newTotalMarkets: number) => {
    try {
      setIsLoading(true)
      const configToUpdate = {
        totalMarkets: newTotalMarkets || 0,
        useScanner: configResponse?.useScanner ?? false,
      }

      await configsService.postConfig(configToUpdate)
      toast("Quantidade de mercados atualizado com sucesso!", {
        type: "success",
      })
      setTotalMarkets(newTotalMarkets || 0)
    } catch (error: any) {
      toast(error?.message ?? "Deu erro pra atualizar as configurações, avisa o time de tech.", {
        type: "error",
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    handleGetConfigs()
  }, [])

  useEffect(() => {
    animateValue(ref.current as HTMLElement, 0, totalMarkets, 1000)
  }, [totalMarkets])

  return (
    <>
      <ContainerPage>
        <ReturnArea title="Mercados" />

        <BoxAlign>
          <TitlePage>Mercados</TitlePage>

          <Button
            style={{ marginBottom: "3rem", marginTop: "3rem" }}
            onClick={() => {
              setDialogEditSeparation({
                isOpen: true,
                data: totalMarkets,
              })
            }}
          >
            <FaCog size={"1rem"} style={{ marginRight: "0.6rem" }} /> Editar
          </Button>
        </BoxAlign>

        <Container>
          <TextWarning ref={ref} />
          <TextHelper>Quantidade de mercados</TextHelper>
        </Container>
      </ContainerPage>

      <DialogEdit
        submit={handleUpdateConfigs}
        setIsOpen={setDialogEditSeparation}
        title="Mercados"
        field="totalMarkets"
        isOpen={dialogEditSeparation.isOpen}
        data={dialogEditSeparation.data}
        defaultValue={totalMarkets}
      />
    </>
  )
}
